import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { Button } from "@shadcn-in-nx/ui/button";
import { Input } from "@shadcn-in-nx/ui/input";
import { useTranslation } from "react-i18next";

export default function ShareUrlCopyField({ url }) {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="flex gap-2">
            <Input value={url} readOnly className="text-sm bg-muted" />
            <Button variant="outline" size="icon" onClick={handleCopy}>
                {copied ? (
                    <Check className="h-4 w-4 text-green-600" />
                ) : (
                    <Copy className="h-4 w-4" />
                )}
            </Button>
        </div>
    );
}
